// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"FavouritesUiDynamicBuyerInfoModal":"6c5215d0","auroraAdobeDmpJs":"eb0cfc12","SmartBannerFullScreen":"6f0153d8"}[chunkId] + ".js";
};